// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top{
    background-color: #17c7fc; margin-top: 80px; padding: 150px 0;
}
.bold-600{
    font-weight: 600;
    font-family: 'Montserrat';
}
.font-24{
    font-size: 28px;
    font-family: 'Montserrat';
}
.front{
    /* margin-top: 80px; */
     background-image: url(/assets/images/front/Rectangle.svg);
     height: 275px;
     background: #17c7fc;
    overflow: hidden;
}
.rate{
    position: absolute;
    width: 100%;
    top: 170px;
}

.copy{
    position: absolute;
    border-radius: 60px;
    padding: 18px 60px;
    font-size: 28px;
    text-transform: uppercase;
    height: 74px;
    cursor: pointer;
    background: #0070C0;
    text-align: center;
    color: white;
    width: 100%;
}
.block{
    background: #D9D9D9;

}
h6{
    margin: 0;
    font-weight: 500;
    color: #000;
}
.mob{
    display: none;
}
@media screen and (max-width:600px) {
    .top{
        display: none;
    }
    .front{
        margin-top: 30px;
        display: none;
        margin-bottom: 150px;
    }
    .rate{
        position: relative;
        top: 60px;
        margin-bottom: 30px;
        background-color: #17c7fc;
    } 
    .copy{
        position: relative;
        padding: 12px 60px;
        font-size: 24px;
        height: 60px;
        /* border-radius: 30px;
        padding: 12px 24px;
        margin-top: 20px;
        margin-bottom: 40px; */
    }
    .border-right-1{
        border-bottom: 2px solid #707070;
    }
    .btn-login,.btn-sign,.btn p{
        width: 100%;
    }
    .mob-promo{
        background: #17c7fc;
    }
    .font-24,.bold-600{
        font-size: 16px; 
    }
    .mob{
        display: block;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/studentDashboard/start-now/start-now.component.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB,EAAE,gBAAgB,EAAE,gBAAgB;AACjE;AACA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,sBAAsB;KACrB,yDAAyD;KACzD,aAAa;KACb,mBAAmB;IACpB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;AACA;IACI,mBAAmB;;AAEvB;AACA;IACI,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,aAAa;AACjB;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,gBAAgB;QAChB,aAAa;QACb,oBAAoB;IACxB;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,mBAAmB;QACnB,yBAAyB;IAC7B;IACA;QACI,kBAAkB;QAClB,kBAAkB;QAClB,eAAe;QACf,YAAY;QACZ;;;8BAGsB;IAC1B;IACA;QACI,gCAAgC;IACpC;IACA;QACI,WAAW;IACf;IACA;QACI,mBAAmB;IACvB;IACA;QACI,eAAe;IACnB;IACA;QACI,cAAc;IAClB;AACJ","sourcesContent":[".top{\n    background-color: #17c7fc; margin-top: 80px; padding: 150px 0;\n}\n.bold-600{\n    font-weight: 600;\n    font-family: 'Montserrat';\n}\n.font-24{\n    font-size: 28px;\n    font-family: 'Montserrat';\n}\n.front{\n    /* margin-top: 80px; */\n     background-image: url(/assets/images/front/Rectangle.svg);\n     height: 275px;\n     background: #17c7fc;\n    overflow: hidden;\n}\n.rate{\n    position: absolute;\n    width: 100%;\n    top: 170px;\n}\n\n.copy{\n    position: absolute;\n    border-radius: 60px;\n    padding: 18px 60px;\n    font-size: 28px;\n    text-transform: uppercase;\n    height: 74px;\n    cursor: pointer;\n    background: #0070C0;\n    text-align: center;\n    color: white;\n    width: 100%;\n}\n.block{\n    background: #D9D9D9;\n\n}\nh6{\n    margin: 0;\n    font-weight: 500;\n    color: #000;\n}\n.mob{\n    display: none;\n}\n@media screen and (max-width:600px) {\n    .top{\n        display: none;\n    }\n    .front{\n        margin-top: 30px;\n        display: none;\n        margin-bottom: 150px;\n    }\n    .rate{\n        position: relative;\n        top: 60px;\n        margin-bottom: 30px;\n        background-color: #17c7fc;\n    } \n    .copy{\n        position: relative;\n        padding: 12px 60px;\n        font-size: 24px;\n        height: 60px;\n        /* border-radius: 30px;\n        padding: 12px 24px;\n        margin-top: 20px;\n        margin-bottom: 40px; */\n    }\n    .border-right-1{\n        border-bottom: 2px solid #707070;\n    }\n    .btn-login,.btn-sign,.btn p{\n        width: 100%;\n    }\n    .mob-promo{\n        background: #17c7fc;\n    }\n    .font-24,.bold-600{\n        font-size: 16px; \n    }\n    .mob{\n        display: block;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
